import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  line: '',
  plan: '',
  activeFrom: '',
  activeTo: '',
  commissionType: 'RATE',
  lineCommissionValue: 0,
  ValueCurrency: '39735',
  lineCommissionRate: 0,
  ApplicableOn: '',
};

export const drawerSections = (
  values: Record<string, any> = initialValues,
  lovs: Record<string, Record<string, string>>,
  isDirectSalesforce: boolean
): IDynamicFormWidgetSection[] => {
  const isRate = values.commissionType?.toLowerCase() === 'rate';

  return [
    {
      inputs: {
        line: {
          name: 'line',
          title: 'Line',
          type: FormFieldType.select,
          placeholder: 'Line',
          value: !isEmpty(values.line) ? values.line : '',
          required: true,
          selectOptions: lovs.line || {},
        },
        plan: {
          name: 'plan',
          title: 'Plan(s)',
          type: FormFieldType.multiSelect,
          placeholder: 'Plan(s)',
          value: !isEmpty(values.plan) ? values.plan : '',
          required: true,
          selectOptions: lovs.plan || {},
        },
        commissionType: {
          name: 'commissionType',
          title: 'Commission Type',
          placeholder: 'Commission Type',
          type: FormFieldType.select,
          value: !isEmpty(values.commissionType) ? values.commissionType : '',
          selectOptions: lovs.commissionType || {},
        },
        lineCommissionValue: {
          name: 'lineCommissionValue',
          title: 'Commission',
          type: FormFieldType.currency,
          placeholder: 'Commission',
          value: values.lineCommissionValue,
          required: !isRate,
          hidden: isRate || isDirectSalesforce,
          disabled: isRate,
        },
        ValueCurrency: {
          name: 'ValueCurrency',
          title: 'Commission Currency',
          placeholder: 'Commission Currency',
          type: FormFieldType.select,
          value: !isEmpty(values.ValueCurrency) ? values.ValueCurrency : '',
          required: !isRate,
          hidden: isRate || isDirectSalesforce,
          disabled: isRate,
          injectGlobalLov: {
            type: 'currency',
            value: 'Id',
            display: 'Title',
          },
        },
        lineCommissionRate: {
          name: 'lineCommissionRate',
          title: 'Commission Rate',
          type: FormFieldType.percentage,
          placeholder: 'Commission Rate',
          value: values.lineCommissionRate,
          required: isRate,
          hidden: !isRate || isDirectSalesforce,
          disabled: !isRate,
        },
        ApplicableOn: {
          name: 'ApplicableOn',
          title: 'Commission Applicable On',
          placeholder: 'Commission Applicable On',
          type: FormFieldType.select,
          value: !isEmpty(values.ApplicableOn) ? values.ApplicableOn : '',
          required: isRate || !isDirectSalesforce,
          hidden: !isRate || isDirectSalesforce,
          disabled: !isRate || isDirectSalesforce,
          selectOptions: lovs.ApplicableOn || {},
        },
        activeFrom: {
          name: 'activeFrom',
          title: 'Active From',
          placeholder: 'Active From',
          type: FormFieldType.date,
          value: values.activeFrom,
          required: true,
        },
        activeTo: {
          name: 'activeTo',
          title: 'Active To',
          placeholder: 'Active To',
          type: FormFieldType.date,
          value: values.activeTo,
          required: true,
        },
      },
    },
  ];
};
